
export { LucideIcon } from "/codebuild/output/src2176744316/src/packages/shared-components/src/components/LucideIcon.tsx"